import { Entity } from '@aninix-inc/model'
import * as R from 'ramda'
import * as React from 'react'
import { Property } from './property'

export interface IProps {
  segments: [Entity, Entity][]
}

export const Properties: React.FCC<IProps> = ({ segments }) => {
  return (
    <>
      {segments.length > 0 &&
        segments.map((segment) => (
          <Property
            key={`${R.head(segment)!.id}-${R.last(segment)!.id}`}
            segment={segment}
          />
        ))}
    </>
  )
}

Properties.displayName = 'Properties'
